interface BrandMarkProps {
  size?: number;
  color?: string;
}

export function BrandMark({ size = 200, color = '#2d2d2d' }: BrandMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="217 157 590 685"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Top wing shape */}
      <path
        fill={color}
        d="M511.964 156.887C525.432 162.801 545.501 173.891 559.283 180.896L655.777 229.874L754.233 279.503C769.802 287.355 791.435 297.508 806.04 306.001L806.065 385.026C806.071 397.275 806.401 410.964 806.119 423.082L613.12 325.301L563.418 300.17C554.979 295.869 545.296 290.565 536.899 286.588L533.188 284.715C526.14 281.101 518.811 277.223 511.686 273.831C491.8 283.063 468.987 295.455 449.231 305.46L329.909 366.139L330.043 532.607C311.514 526.773 288.526 517.607 269.935 510.802L238.642 499.364C233.439 497.472 226.923 495.348 221.99 493.21L221.9 304.752C239.117 295.45 257.677 286.311 275.178 277.34L400.049 213.756L475.012 175.543L499.205 163.242C502.739 161.45 508.421 158.352 511.964 156.887Z"
      />
      {/* Bottom wing shape */}
      <path
        fill={color}
        d="M693.501 460.959C715.631 468.745 737.714 476.661 759.75 484.709C773.034 489.526 788.446 494.715 801.429 499.921L801.371 612.146C801.344 638.491 800.903 666.121 801.482 692.359C776.663 703.935 749.57 718.473 725.101 731.017L585.147 802.608C564.985 812.907 544.252 824.226 524.018 834.089C519.964 836.044 515.537 838.476 511.506 840.573L363.402 765.582C360.916 764.612 356.228 762.021 353.68 760.699L259.737 713.264C246.988 706.807 229.722 698.637 217.541 691.677C217.407 651.996 216.97 611.156 217.466 571.542C227.568 576.003 238.887 582.019 248.922 587.044L301.161 613.139L511.638 719.928L619.341 665.079C643.117 653.011 669.415 639.03 693.356 627.887C692.61 598.525 693.155 567.516 693.131 537.988C693.11 513.269 692.505 485.352 693.501 460.959Z"
      />
      {/* Center rectangle */}
      <path
        fill={color}
        d="M396.593 387.243C403.371 386.3 426.476 386.922 434.731 386.911L518.898 386.879L591.816 386.894C597.71 386.895 621.346 386.612 625.635 387.414L626.312 387.594C627.379 389.02 626.927 451.642 626.929 457.841L626.966 605.499L396.538 605.501L396.593 387.243Z"
      />
    </svg>
  );
}

export default function LogoPreview() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-16 py-20">
      <div
        className="flex flex-col items-center gap-10 p-12"
        style={{
          background: 'repeating-conic-gradient(#e5e7eb 0% 25%, #ffffff 0% 50%) 0 0 / 24px 24px',
        }}
      >
        <p className="text-gray-500 text-xs font-mono bg-white/80 px-3 py-1 rounded">
          On transparent (checkerboard)
        </p>
        <BrandMark size={280} color="#2d2d2d" />
        <div className="flex items-end gap-8">
          <BrandMark size={120} color="#2d2d2d" />
          <BrandMark size={64} color="#2d2d2d" />
          <BrandMark size={40} color="#2d2d2d" />
        </div>
      </div>
      <div className="flex items-center gap-12 bg-[#1a3a3a] px-12 py-10 rounded-xl">
        <p className="text-white/60 text-xs font-mono">On dark background (white)</p>
        <BrandMark size={120} color="white" />
        <BrandMark size={64} color="white" />
        <BrandMark size={40} color="white" />
      </div>
    </div>
  );
}
